module.exports = __webpack_public_path__ + "static/media/MenuIcons.c520cd26.svg";